import { Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';
import { KPIChartService } from '../../shared/kpi-charts-service';
import { SalesOrder,  SubSalesOrder,ElectricalDesignEngineer,MechanicalDesignEngineerKPI2,ProjectEngineerKPI2, MarketingEngineerKPI2,MechanicalDesignEngineerKPI,FunctionStatus, SOStatus, SSOStatus, monthFilter, MarketingEngineer, userFilterOption, UiWaitReadySO, CommentsPR, PmTechnicalIP, Equipment,ElectricalDesignEngineerKPI, MechanicalDesignEngineer, ProjectEngineer, ProjectEngineerKPI,ElectricalDesignEngineerKPI2, yearFilter } from '../../shared/misc-classes';
import * as Highcharts from 'highcharts';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-kpis-v5',
  templateUrl: './kpis-v5.component.html',
  styleUrls: ['./kpis-v5.component.css']
})
export class KpisV5Component implements OnInit {

  _soObjList2: Array<SalesOrder>;

  ElecDesignEngg= '';
  ElecDesignEnggArray:string[]= [];
  MechDesignEngg= '';
  MechanicalDesignEnggArray:string[]= [];
  ProjectEngg= '';
  ProjectEnggArray:string[]= [];
  MarketingEngg= '';
  MarketingEnggArray:string[]= [];

  isUserSelectionFilterSelected:boolean = false;
  isMechUserSelectionFilterSelected:boolean = false;
  isPEUserSelectionFilterSelected:boolean = false;
  isMarketingEnggUserSelectionFilterSelected:boolean = false;
  userSelectionType:userFilterOption = userFilterOption.All;
  userMechSelectionType:userFilterOption = userFilterOption.All;
  userPESelectionType:userFilterOption = userFilterOption.All;
  userMarketingEnggSelectionType:userFilterOption = userFilterOption.All;

  Highcharts = Highcharts;

  isLoading: boolean = false;
  isLoading2:boolean = false;
  isDataViewUpdated: boolean = false;

  totalDataEDE: any;
  totalDataMDE: any;
  totalDataPE: any;
  totalDataME: any;
  totalDataEDEKpiChartOptionsSO: Highcharts.Options;
  totalDataMDEKpiChartOptionsSO: Highcharts.Options;
  totalDataPEKpiChartOptionsSO: Highcharts.Options;
  totalDataMEKpiChartOptionsSO: Highcharts.Options;

  ElectricalDesignEngineerKPIArray:Array<ElectricalDesignEngineerKPI2> = [];
  MechanicalDesignEngineerKPIArray:Array<MechanicalDesignEngineerKPI2> = [];
  ProjectEngineerKPIArray:Array<ProjectEngineerKPI2> = [];
  MarketingEngineerKPIArray:Array<MarketingEngineerKPI2> = [];

  isYearFilterSelectedEDE1:boolean = false;
  yearFilterEDE1:yearFilter;

  isYearFilterSelectedMDE1:boolean = false;
  yearFilterMDE1:yearFilter;

  isYearFilterSelectedPE1:boolean = false;
  yearFilterPE1:yearFilter;

  isYearFilterSelectedME1:boolean = false;
  yearFilterME1:yearFilter;

  constructor(public _dataService: DataService,private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    this._dataService.currPageName = 'Individual KPI 2';
    try{
      this.loadSettingsFromCookies();
    }catch(e){
      console.log(e);
    }
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder_2(0).subscribe((_soObjAr2:Array<SalesOrder>) => {
        this._soObjList2 = _soObjAr2;
        this.loadEDEData();
        this.filterRows();

        this.loadMDEData();
        this.filterRowsMech();
        
       this.filterRowsPE();
        this.loadPEData();

        this.filterRowsME();
        this.loadMEData();
      });
    });
  }

  filterRowsMech(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic3();
      this.loadMDEData();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  filterRowsPE(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic4();
      this.loadPEData();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  filterRowsME(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic5();
      this.loadMEData();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  loadSettingsFromCookies(){

    let _tmpElecDesignEngg = this._dataService.getCookie('s-elecDesignEngg-indv-kpi-2');
    
    if(_tmpElecDesignEngg != "0" && _tmpElecDesignEngg != ""){
      this.ElecDesignEngg = _tmpElecDesignEngg;
      this.ElecDesignEnggArray = _tmpElecDesignEngg.split(",");
      this.isUserSelectionFilterSelected = true;
      this.userSelectionType = userFilterOption.ElectricDesignEngineer;
    }else{
      this.isUserSelectionFilterSelected = false;
      this.userSelectionType = userFilterOption.All;
    }

    let _tmpMechDesignEngg = this._dataService.getCookie('s-mdeDesignEngg-indv-kpi-2');

    if(_tmpMechDesignEngg != "0" && _tmpMechDesignEngg != ""){
      this.MechDesignEngg = _tmpMechDesignEngg;
      this.MechanicalDesignEnggArray = _tmpMechDesignEngg.split(",");
      this.isMechUserSelectionFilterSelected = true;
      this.userMechSelectionType = userFilterOption.MechanicalDesignEngineer;
    }else{
      this.isMechUserSelectionFilterSelected = false;
      this.userMechSelectionType = userFilterOption.All;
    }
    
    let _tmpPEDesignEngg = this._dataService.getCookie('s-peDesignEngg-indv-kpi-2');
  
    if(_tmpPEDesignEngg != "0" && _tmpPEDesignEngg != ""){
      this.ProjectEngg = _tmpPEDesignEngg;
      this.ProjectEnggArray = _tmpPEDesignEngg.split(",");
      this.isPEUserSelectionFilterSelected = true;
      this.userPESelectionType = userFilterOption.ProjectEngineer;
    }else{
      this.isPEUserSelectionFilterSelected = false;
      this.userPESelectionType = userFilterOption.All;
    }

    let _tmpMEDesignEngg = this._dataService.getCookie('s-meDesignEngg-indv-kpi-2');
 
    if(_tmpMEDesignEngg != "0" && _tmpMEDesignEngg != ""){
      this.MarketingEngg = _tmpMEDesignEngg;
      this.MarketingEnggArray = _tmpMEDesignEngg.split(",");
      this.isMarketingEnggUserSelectionFilterSelected = true;
      this.userMarketingEnggSelectionType = userFilterOption.MarketingEngineer;
    }else{
      this.isMarketingEnggUserSelectionFilterSelected = false;
      this.userMarketingEnggSelectionType = userFilterOption.All;
    }

    let _tmpYearSel1:string = this._dataService.getCookie('s-year-sel-pe1');
    if(_tmpYearSel1){
      this.isYearFilterSelectedPE1 = (_tmpYearSel1 == "1");

      let _tmpYearVal1:string = this._dataService.getCookie('s-year-val-pe1');
      if(_tmpYearVal1){        
        this.yearFilterPE1 = yearFilter.getObjFromCookieStr(_tmpYearVal1);
      }
    }
    let _tmpYearSelEDE1:string = this._dataService.getCookie('s-year-sel-ede1');
    if(_tmpYearSelEDE1){
      this.isYearFilterSelectedEDE1 = (_tmpYearSelEDE1 == "1");

      let _tmpYearValEDE1:string = this._dataService.getCookie('s-year-val-ede1');
      if(_tmpYearValEDE1){        
        this.yearFilterEDE1 = yearFilter.getObjFromCookieStr(_tmpYearValEDE1);
      }
    }
    let _tmpYearSelMDE1:string = this._dataService.getCookie('s-year-sel-mde1');
    if(_tmpYearSelMDE1){
      this.isYearFilterSelectedMDE1 = (_tmpYearSelMDE1 == "1");

      let _tmpYearValMDE1:string = this._dataService.getCookie('s-year-val-mde1');
      if(_tmpYearValMDE1){        
        this.yearFilterMDE1 = yearFilter.getObjFromCookieStr(_tmpYearValMDE1);
      }
    }
    let _tmpYearSelME1:string = this._dataService.getCookie('s-year-sel-me1');
    if(_tmpYearSelME1){
      this.isYearFilterSelectedME1 = (_tmpYearSelME1 == "1");

      let _tmpYearValME1:string = this._dataService.getCookie('s-year-val-me1');
      if(_tmpYearValME1){        
        this.yearFilterME1 = yearFilter.getObjFromCookieStr(_tmpYearValME1);
      }
    }

    let _currDate:Date = new Date();
    if(this.yearFilterPE1 == null){
      this.yearFilterPE1 = new yearFilter(_currDate.getFullYear());
    }
    if(this.yearFilterEDE1 == null){
      this.yearFilterEDE1 = new yearFilter(_currDate.getFullYear());
    }
    if(this.yearFilterMDE1 == null){
      this.yearFilterMDE1 = new yearFilter(_currDate.getFullYear());
    }
    if(this.yearFilterME1 == null){
      this.yearFilterME1 = new yearFilter(_currDate.getFullYear());
    }
  }

  saveSettingsToCookies() {
    this._dataService.setCookie('s-elecDesignEngg-indv-kpi-2', this.isUserSelectionFilterSelected ? "1":"0");
        if(this.isUserSelectionFilterSelected){
          this._dataService.setCookie('s-elecDesignEngg-indv-kpi-2', this.ElecDesignEnggArray + '');
        }

        this._dataService.setCookie('s-mdeDesignEngg-indv-kpi-2', this.isMechUserSelectionFilterSelected ? "1":"0");
        if(this.isMechUserSelectionFilterSelected){
          this._dataService.setCookie('s-mdeDesignEngg-indv-kpi-2', this.MechanicalDesignEnggArray + '');
        }

        this._dataService.setCookie('s-peDesignEngg-indv-kpi-2', this.isPEUserSelectionFilterSelected ? "1":"0");
        if(this.isPEUserSelectionFilterSelected){
          this._dataService.setCookie('s-peDesignEngg-indv-kpi-2', this.ProjectEnggArray + '');
        }

        this._dataService.setCookie('s-meDesignEngg-indv-kpi-2', this.isMarketingEnggUserSelectionFilterSelected ? "1":"0");
        if(this.isMarketingEnggUserSelectionFilterSelected){
          this._dataService.setCookie('s-meDesignEngg-indv-kpi-2', this.MarketingEnggArray + '');
        }

        this._dataService.setCookie('s-year-sel-pe1', this.isYearFilterSelectedPE1 ? "1":"0");
        if (this.isYearFilterSelectedPE1) {
          this._dataService.setCookie('s-year-val-pe1', this.yearFilterPE1.getCookieStr());
        }
        this._dataService.setCookie('s-year-sel-ede1', this.isYearFilterSelectedEDE1 ? "1":"0");
        if (this.isYearFilterSelectedEDE1) {
          this._dataService.setCookie('s-year-val-ede1', this.yearFilterEDE1.getCookieStr());
        }
        this._dataService.setCookie('s-year-sel-mde1', this.isYearFilterSelectedMDE1 ? "1":"0");
        if (this.isYearFilterSelectedMDE1) {
          this._dataService.setCookie('s-year-val-mde1', this.yearFilterMDE1.getCookieStr());
        }
        this._dataService.setCookie('s-year-sel-me1', this.isYearFilterSelectedME1 ? "1":"0");
        if (this.isYearFilterSelectedME1) {
          this._dataService.setCookie('s-year-val-me1', this.yearFilterME1.getCookieStr());
        }
    
  }

  clearEDEFilters(){
    this.ElecDesignEngg = "";
    this.userSelectionType = userFilterOption.All;
    this.ElecDesignEnggArray = [];
    this.isUserSelectionFilterSelected = false;
    this.isYearFilterSelectedEDE1 = false;
    this.saveSettingsToCookies();
    this.filterRows();
  }

  clearMDEFilters(){
    this.MechDesignEngg = "";
    this.userMechSelectionType = userFilterOption.All;
    this.MechanicalDesignEnggArray = [];
    this.isMechUserSelectionFilterSelected = false;
    this.isYearFilterSelectedMDE1 = false;
    this.saveSettingsToCookies();
    this.filterRowsMech();
  }

  clearPEFilters(){
    this.ProjectEngg = "";
    this.userPESelectionType = userFilterOption.All;
    this.ProjectEnggArray = [];
    this.isPEUserSelectionFilterSelected = false;
    this.isYearFilterSelectedPE1 = false;
    this.saveSettingsToCookies();
    this.filterRowsPE();
  }

  clearMEFilters(){
    this.MarketingEngg = "";
    this.userMarketingEnggSelectionType = userFilterOption.All;
    this.MarketingEnggArray = [];
    this.isMarketingEnggUserSelectionFilterSelected = false;
    this.isYearFilterSelectedME1 = false;
    this.saveSettingsToCookies();
    this.filterRowsME();
  }

  filterRows1(_event){
    this.ElecDesignEngg = _event.value;
    this.userSelectionType = userFilterOption.ElectricDesignEngineer;
    this.ElecDesignEnggArray = _event.value;
    if(this.ElecDesignEngg == null || this.ElecDesignEngg == ""){
      this.isUserSelectionFilterSelected = false;
    }else{
      this.isUserSelectionFilterSelected = true;
    }
    this.filterRows();
  }

  
  filterRows2(_event){
    this.MechDesignEngg = _event.value;
    this.userMechSelectionType = userFilterOption.MechanicalDesignEngineer;
    this.MechanicalDesignEnggArray = _event.value;
    if(this.MechDesignEngg == null || this.MechDesignEngg == ""){
      this.isMechUserSelectionFilterSelected = false;
    }else{
      this.isMechUserSelectionFilterSelected = true;
    }
    this.filterRowsMech();
    
  }

  filterRows3(_event){
    this.ProjectEngg = _event.value;
    this.userPESelectionType = userFilterOption.ProjectEngineer;
    this.ProjectEnggArray = _event.value;
    if(this.ProjectEngg == null || this.ProjectEngg == ""){
      this.isPEUserSelectionFilterSelected = false;
    }else{
      this.isPEUserSelectionFilterSelected = true;
    }
    this.filterRowsPE();
    
  }

  filterRows4(_event){
    this.MarketingEngg = _event.value;
    this.userMarketingEnggSelectionType = userFilterOption.MarketingEngineer;
    this.MarketingEnggArray = _event.value;
    if(this.MarketingEngg == null || this.MarketingEngg == ""){
      this.isMarketingEnggUserSelectionFilterSelected = false;
    }else{
      this.isMarketingEnggUserSelectionFilterSelected = true;
    }
    this.filterRowsME();
    
  }

  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.loadEDEData();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  loadEDEData(){
    this.isLoading2 = true;
    let ElecDesignEngineers = this._dataService.electricalDesignEngineer;
    
    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];
   
    if(this.isYearFilterSelectedEDE1==true){ 

      this.ElectricalDesignEngineerKPIArray =[];
    ElecDesignEngineers.forEach((ele:ElectricalDesignEngineer) => {
      let _totalQtySO: number = 0;
      let _totalContractualValue: number = 0;
  
      let _totalQtySOC30Done: number = 0;
      let _totalContractualValueC30Done: number = 0;
  
      let _totalQtySOC40Done: number = 0;
      let _totalContractualValueC40Done: number = 0;
  
      let _totalQtySODispatch: number = 0;
      let _totalContractualValueDispatch: number = 0;
  
      let _showSOWithNoSSO: boolean = true;
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              
               // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  if(subSaleOrder.enggDrawIP.electricalDesignEngineerId == ele.electricalDesignEngineerId){
                    // let currentYear:Date = new Date();
                    let selYear:Date = new Date(this.yearFilterEDE1.selYear,1,1);

                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if(_equpList.includes(e.equipmentType)==true){
                        var temp: number = parseInt(e.panelQuantity, 10);

                        var minrFlag : boolean = false;
                        if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                          minrFlag = true;
                        }
        
                        if (temp > 0) {
                          if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                            _totalQtySO += temp;
                            if(minrFlag){
                              _totalContractualValue += parseFloat(e.contractualValue);
                            }
                          }
                          
                          ///Total No. of Panels Engineering C30 done in current year (SLD & Scheme dates both or either one are there count as 1)
                  
                          if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() ) || (subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() ) ){
                            _totalQtySOC30Done +=temp;
                            if(minrFlag){
                              _totalContractualValueC30Done += parseFloat(e.contractualValue);
                            }
                          }
        
                          //Total number of orders C40 done in current year
                          if(subSaleOrder.enggProcureIP.actualC40Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear()){
                            _totalQtySOC40Done += temp;
                            if(minrFlag){
                              _totalContractualValueC40Done += parseFloat(e.contractualValue);
                            }
                          }
        
                          //Total number of panels dispatched in current year
        
                          if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                            // _totalQtySODispatch += temp;
                            if(minrFlag){
                              _totalContractualValueDispatch += parseFloat(e.contractualValue);
                            }
                          }
                        }
                      }
                    });
                    if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                      _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                      }
              }
             
            });
          }
        }
      }

       this.ElectricalDesignEngineerKPIArray.push(new ElectricalDesignEngineerKPI2(ele.electricalDesignEngineerName,_totalQtySO,_totalContractualValue,_totalQtySOC30Done,_totalContractualValueC30Done,_totalQtySOC40Done,
        _totalContractualValueC40Done,_totalQtySODispatch,_totalContractualValueDispatch));
      
    });
    }
    else{
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      this.ElectricalDesignEngineerKPIArray =[];

      ElecDesignEngineers.forEach((ele:ElectricalDesignEngineer) => {
        let _totalQtySO: number = 0;
        let _totalContractualValue: number = 0;
    
        let _totalQtySOC30Done: number = 0;
        let _totalContractualValueC30Done: number = 0;
    
        let _totalQtySOC40Done: number = 0;
        let _totalContractualValueC40Done: number = 0;
    
        let _totalQtySODispatch: number = 0;
        let _totalContractualValueDispatch: number = 0;
    
        let _showSOWithNoSSO: boolean = true;
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO: SalesOrder = this._soObjList2[i];
    
          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
  
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
    
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                
                 // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                    if(subSaleOrder.enggDrawIP.electricalDesignEngineerId == ele.electricalDesignEngineerId){
                      // let currentYear:Date = new Date();
                      subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                        if(_equpList.includes(e.equipmentType)==true){
                          var temp: number = parseInt(e.panelQuantity, 10);
  
                          var minrFlag : boolean = false;
                          if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                            minrFlag = true;
                          }
          
                          if (temp > 0) {
                            // if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                              _totalQtySO += temp;
                              if(minrFlag){
                                _totalContractualValue += parseFloat(e.contractualValue);
                              }
                            // }
                            
                            ///Total No. of Panels Engineering C30 done in current year (SLD & Scheme dates both or either one are there count as 1)
                    
                            // if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() ) || (subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() ) ){
                              if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null ) || (subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null ) ){
                              _totalQtySOC30Done +=temp;
                              if(minrFlag){
                                _totalContractualValueC30Done += parseFloat(e.contractualValue);
                              }
                            }
          
                            //Total number of orders C40 done in current year
                            // if(subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear()){
                              if(subSaleOrder.enggProcureIP.actualC40Date != null){
                              _totalQtySOC40Done += temp;
                              if(minrFlag){
                                _totalContractualValueC40Done += parseFloat(e.contractualValue);
                              }
                            }
          
                            //Total number of panels dispatched in current year
          
                            // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && currentYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                              if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                              // _totalQtySODispatch += temp;
                              if(minrFlag){
                                _totalContractualValueDispatch += parseFloat(e.contractualValue);
                              }
                            }
                          }
                        }
                      });
                      // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                        if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                        _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                        }
                }
              }
              });
            }
          }
        }
  
         this.ElectricalDesignEngineerKPIArray.push(new ElectricalDesignEngineerKPI2(ele.electricalDesignEngineerName,_totalQtySO,_totalContractualValue,_totalQtySOC30Done,_totalContractualValueC30Done,_totalQtySOC40Done,
          _totalContractualValueC40Done,_totalQtySODispatch,_totalContractualValueDispatch));
        
      });
    }

this.isLoading2 = false;
  }

  filterRowsLogic2() {
    let ElecDesignEngineers = this._dataService.electricalDesignEngineer;
    let _totalQtySO: number = 0;
    let _totalContractualValue: number = 0;

    let _totalQtySOC30Done: number = 0;
    let _totalContractualValueC30Done: number = 0;

    let _totalQtySOC40Done: number = 0;
    let _totalContractualValueC40Done: number = 0;

    let _totalQtySODispatch: number = 0;
    let _totalContractualValueDispatch: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    if(this.isYearFilterSelectedEDE1==true){ 

    ElecDesignEngineers.forEach((ele:ElectricalDesignEngineer) => {
    let _showSOWithNoSSO: boolean = true;
    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList2[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        //filters need to be added for user
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);
        //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
          // let currentYear:Date = new Date();
          let selYear:Date = new Date(this.yearFilterEDE1.selYear,1,1);
          
          _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
            if(subSaleOrder.enggDrawIP.electricalDesignEngineerId == ele.electricalDesignEngineerId){
            //Total No of order in hand
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)==true) {
                var temp: number = parseInt(e.panelQuantity, 10);
                var minrFlag : boolean = false;
                if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                  minrFlag = true;
                }

                if (temp > 0) {
                  if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                    _totalQtySO += temp;
                    if(minrFlag){
                      _totalContractualValue += parseFloat(e.contractualValue);
                    }
                  }

                  ///Total No. of Panels Engineering C30 done in current year (SLD & Scheme dates both or either one are there count as 1)
          
                  if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() ) || (subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() ) ){
                    _totalQtySOC30Done +=temp;
                    if(minrFlag){
                      _totalContractualValueC30Done += parseFloat(e.contractualValue);
                    }
                  }

                  //Total number of orders C40 done in current year
                  if(subSaleOrder.enggProcureIP.actualC40Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear()){
                    _totalQtySOC40Done += temp;
                    if(minrFlag){
                      _totalContractualValueC40Done += parseFloat(e.contractualValue);
                    }
                  }

                  //Total number of panels dispatched in current year

                  if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                    // _totalQtySODispatch += temp;
                    if(minrFlag){
                      _totalContractualValueDispatch += parseFloat(e.contractualValue);
                    }
                  }
                }
              }
            });
            if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
              _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
              }
          }
            
          });
        }
      }
    }
  });
    }
    else {
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      ElecDesignEngineers.forEach((ele:ElectricalDesignEngineer) => {
        let _showSOWithNoSSO: boolean = true;
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO: SalesOrder = this._soObjList2[i];
    
          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders1(_tmpSO.subSalesOrder);
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
    
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
              // let currentYear:Date = new Date();
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                if(subSaleOrder.enggDrawIP.electricalDesignEngineerId == ele.electricalDesignEngineerId){
                //Total No of order in hand
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)==true) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    var minrFlag : boolean = false;
                    if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                      minrFlag = true;
                    }
    
                    if (temp > 0) {
                        _totalQtySO += temp;
                        if(minrFlag){
                          _totalContractualValue += parseFloat(e.contractualValue);
                        }
    
                      ///Total No. of Panels Engineering C30 done in current year (SLD & Scheme dates both or either one are there count as 1)
              
                      // if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() ) || (subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() ) ){
                        if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null) ){
                        _totalQtySOC30Done +=temp;
                        if(minrFlag){
                          _totalContractualValueC30Done += parseFloat(e.contractualValue);
                        }
                      }
    
                      //Total number of orders C40 done in current year
                      // if(subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear()){
                        if(subSaleOrder.enggProcureIP.actualC40Date != null){
                        _totalQtySOC40Done += temp;
                        if(minrFlag){
                          _totalContractualValueC40Done += parseFloat(e.contractualValue);
                        }
                      }
    
                      //Total number of panels dispatched in current year
    
                      // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && currentYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                        if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                        // _totalQtySODispatch += temp;
                        if(minrFlag){
                          _totalContractualValueDispatch += parseFloat(e.contractualValue);
                        }
                      }
                    }
                  }
                });
                // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                  if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                    _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                    }
              }
                
              });
            }
          }
        }
      });
    }
  
    if(_totalQtySO!=0 || _totalQtySOC30Done!=0 || _totalQtySOC40Done!= 0 || _totalQtySODispatch!=0){
      this.totalDataEDE = [{
        "data":[
          {
            name: 'Total No. of orders in hand - OBL',
            x: Math.round(_totalContractualValue * 100)/100,
            y: _totalQtySO,
            color: '#ff000f'
          },
          {
            name: 'Total No. of Panels Engineering C30 done in current year',
            x: Math.round(_totalContractualValueC30Done * 100)/100,
            y:_totalQtySOC30Done,
            color: '#262626'
          },
          {
            name: 'Total No. of orders C40 done in current year',
            x:Math.round(_totalContractualValueC40Done * 100)/100,
            y: _totalQtySOC40Done,
           color: '#6e6e6e'
          },
          {
            name: 'Total No. of panels dispatched in current year',
            x:Math.round(_totalContractualValueDispatch * 100)/100,
            y: _totalQtySODispatch,
             color: '#a9a9a9'
          }
          
        ]
      }        
     ];
    }
    else this.totalDataEDE= null;

  this.totalDataEDEKpiChartOptionsSO = this._kpiCharServ.getPieChartOptionsKPI(this.totalDataEDE,"Electrical Design <br> Engineer KPI");  
    this.isDataViewUpdated = true;
    setTimeout(() => {
      this.isDataViewUpdated = false;
    }, 1000);
  }

  filterRowsLogic3() {
    let MDEDesignEngineers = this._dataService.mechanicalDesignEngineers;
    let _totalQtySO: number = 0;
    let _totalContractualValue: number = 0;

    let _totalQtySOC50Done: number = 0;
    let _totalContractualValueC50Done: number = 0;


    let _totalQtySODispatch: number = 0;
    let _totalContractualValueDispatch: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];
    if(this.isYearFilterSelectedMDE1==true){
    MDEDesignEngineers.forEach((mde:MechanicalDesignEngineer) => {
    let _showSOWithNoSSO: boolean = true;
    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList2[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        //filters need to be added for user
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrdersMech(_tmpSO.subSalesOrder);
        //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
          // let currentYear:Date = new Date();
          let selYear:Date =  new Date(this.yearFilterMDE1.selYear,1,1);
         
          _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
            if(subSaleOrder.enggDrawIP.mechanicalDesignEngineerId == mde.mechanicalDesignEngineerId){
            
            //Total No of order in hand
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)==true) {
                var temp: number = parseInt(e.panelQuantity, 10);
                var minrFlag : boolean = false;
                if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                  minrFlag = true;
                }

                if (temp > 0) {
                  if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                    _totalQtySO += temp;
                    if(minrFlag){
                      _totalContractualValue += parseFloat(e.contractualValue);
                    }
                    
                  }

                  ///Total number of orders C50 done in current year
          
                  if ((subSaleOrder.enggProcureIP.actualC50Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear() )) {
                    _totalQtySOC50Done +=temp;
                    if(minrFlag){
                      _totalContractualValueC50Done += parseFloat(e.contractualValue);
                    }
                    
                  }

                  //Total number of panels dispatched in current year

                  if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                    // _totalQtySODispatch += temp;
                    if(minrFlag){
                      _totalContractualValueDispatch += parseFloat(e.contractualValue);
                    }
                    
                  }
                }
              }
            });
            if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
              _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
              }
          }
          });
        }
      }
    }
  });
    }
    else{
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      MDEDesignEngineers.forEach((mde:MechanicalDesignEngineer) => {
        let _showSOWithNoSSO: boolean = true;
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO: SalesOrder = this._soObjList2[i];
    
          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrdersMech1(_tmpSO.subSalesOrder);
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
    
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
              // let currentYear:Date = new Date();
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                if(subSaleOrder.enggDrawIP.mechanicalDesignEngineerId == mde.mechanicalDesignEngineerId){
                
                //Total No of order in hand
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)==true) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    var minrFlag : boolean = false;
                    if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                      minrFlag = true;
                    }
    
                    if (temp > 0) {
                      if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                        _totalQtySO += temp;
                        if(minrFlag){
                          _totalContractualValue += parseFloat(e.contractualValue);
                        }
                        
                      }
    
                      ///Total number of orders C50 done in current year
              
                      // if ((subSaleOrder.enggProcureIP.actualC50Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear() )) {
                        if ((subSaleOrder.enggProcureIP.actualC50Date != null)) {
                        _totalQtySOC50Done +=temp;
                        if(minrFlag){
                          _totalContractualValueC50Done += parseFloat(e.contractualValue);
                        }
                        
                      }
    
                      //Total number of panels dispatched in current year
    
                      // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && currentYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                        if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                        // _totalQtySODispatch += temp;
                        if(minrFlag){
                          _totalContractualValueDispatch += parseFloat(e.contractualValue);
                        }
                        
                      }
                    }
                  }
                });
                // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                  if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                    _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                    }
              }
              });
            }
          }
        }
      });
    }
  
    if(_totalQtySO!=0 || _totalQtySOC50Done!=0 || _totalQtySODispatch!=0){
      this.totalDataMDE = [{
        "data":[
          {
            name: 'Total No. of orders in hand - OBL',
            x: Math.round(_totalContractualValue * 100)/100,
            y: _totalQtySO,
            color: '#ff000f'
          },
          {
            name: 'Total No. of orders C50 done in current year',
            x: Math.round(_totalContractualValueC50Done * 100)/100,
            y:_totalQtySOC50Done,
            color: '#262626'
          },
          
          {
            name: 'Total No. of panels dispatched in current year',
            x:Math.round(_totalContractualValueDispatch * 100)/100,
            y: _totalQtySODispatch,
             color: '#6e6e6e'
          }
          
        ]
      }        
     ];
    }
    else this.totalDataMDE= null;

  this.totalDataMDEKpiChartOptionsSO = this._kpiCharServ.getPieChartOptionsKPI(this.totalDataMDE,"Mechanical Design <br> Engineer KPI");  
    this.isDataViewUpdated = true;
    setTimeout(() => {
      this.isDataViewUpdated = false;
    }, 1000);
  }

  loadMDEData(){
    this.isLoading2 = true;
    let MDEDesignEngineers = this._dataService.mechanicalDesignEngineers;
    
    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    if(this.isYearFilterSelectedMDE1){
    this.MechanicalDesignEngineerKPIArray = [];
    MDEDesignEngineers.forEach((mde:MechanicalDesignEngineer) => {
      let _totalQtySO: number = 0;
      let _totalContractualValue: number = 0;
  
      let _totalQtySOC50Done: number = 0;
      let _totalContractualValueC50Done: number = 0;
  
      let _totalQtySODispatch: number = 0;
      let _totalContractualValueDispatch: number = 0;
  
      let _showSOWithNoSSO: boolean = true;
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              
               // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  if(subSaleOrder.enggDrawIP.mechanicalDesignEngineerId == mde.mechanicalDesignEngineerId){
                    // let currentYear:Date = new Date();
                    let selYear:Date = new Date(this.yearFilterMDE1.selYear,1,1);

                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if(_equpList.includes(e.equipmentType)==true){
                        var temp: number = parseInt(e.panelQuantity, 10);

                        var minrFlag : boolean = false;
                        if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                          minrFlag = true;
                        }
        
                        if (temp > 0) {
                          if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                            _totalQtySO += temp;
                            if(minrFlag){
                              _totalContractualValue += parseFloat(e.contractualValue);
                            }
                          }
                          
                          ///Total number of orders C50 done in current year
          
                          if ((subSaleOrder.enggProcureIP.actualC50Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear() )) {
                            _totalQtySOC50Done +=temp;
                            if(minrFlag){
                              _totalContractualValueC50Done += parseFloat(e.contractualValue);
                            }
                          }
                  
                          //Total number of panels dispatched in current year
        
                          if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                            // _totalQtySODispatch += temp;
                            if(minrFlag){
                              _totalContractualValueDispatch += parseFloat(e.contractualValue);
                            }
                          }
                        }
                      }
                    });
                    if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                      _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                      }
              }
             
            });
          }
        }
      }

       this.MechanicalDesignEngineerKPIArray.push(new MechanicalDesignEngineerKPI2(mde.mechanicalDesignEngineerName,_totalQtySO,_totalContractualValue,_totalQtySOC50Done,_totalContractualValueC50Done,
        _totalQtySODispatch,_totalContractualValueDispatch));
      
    });
    }
    else{
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      this.MechanicalDesignEngineerKPIArray = [];
    MDEDesignEngineers.forEach((mde:MechanicalDesignEngineer) => {
      let _totalQtySO: number = 0;
      let _totalContractualValue: number = 0;
  
      let _totalQtySOC50Done: number = 0;
      let _totalContractualValueC50Done: number = 0;
  
      let _totalQtySODispatch: number = 0;
      let _totalContractualValueDispatch: number = 0;
  
      let _showSOWithNoSSO: boolean = true;
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
               // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  if(subSaleOrder.enggDrawIP.mechanicalDesignEngineerId == mde.mechanicalDesignEngineerId){
                    // let currentYear:Date = new Date();
                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if(_equpList.includes(e.equipmentType)==true){
                        var temp: number = parseInt(e.panelQuantity, 10);

                        var minrFlag : boolean = false;
                        if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                          minrFlag = true;
                        }
        
                        if (temp > 0) {
                          // if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                            _totalQtySO += temp;
                            if(minrFlag){
                              _totalContractualValue += parseFloat(e.contractualValue);
                            }
                          // }
                          
                          ///Total number of orders C50 done in current year
          
                          // if ((subSaleOrder.enggProcureIP.actualC50Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear() )) {
                            if ((subSaleOrder.enggProcureIP.actualC50Date != null)) {
                            _totalQtySOC50Done +=temp;
                            if(minrFlag){
                              _totalContractualValueC50Done += parseFloat(e.contractualValue);
                            }
                          }
                  
                          //Total number of panels dispatched in current year
        
                          // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && currentYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                            if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                            // _totalQtySODispatch += temp;
                            if(minrFlag){
                              _totalContractualValueDispatch += parseFloat(e.contractualValue);
                            }
                          }
                        }
                      }
                    });
                    // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                      if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                        _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                        }
              }
            }
            });
          }
        }
      }

       this.MechanicalDesignEngineerKPIArray.push(new MechanicalDesignEngineerKPI2(mde.mechanicalDesignEngineerName,_totalQtySO,_totalContractualValue,_totalQtySOC50Done,_totalContractualValueC50Done,
        _totalQtySODispatch,_totalContractualValueDispatch));
      
    });
    }
this.isLoading2 = false;
  }

  filterRowsLogic4() {
    let PEDesignEngineers = this._dataService.projectEngineers;
    let _totalQtySO: number = 0;
    let _totalContractualValue: number = 0;

    let _totalQtySODrgApprovalDone: number = 0;
    let _totalContractualValueDrgApprovalDone: number = 0;


    let _totalQtySODispatch: number = 0;
    let _totalContractualValueDispatch: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];
    if(this.isYearFilterSelectedPE1==true){
    PEDesignEngineers.forEach((pe:ProjectEngineer) => {
    let _showSOWithNoSSO: boolean = true;
    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList2[i];
      if(_tmpSO.pmCommercial.projectEngineerId != null && _tmpSO.pmCommercial.projectEngineerId != "" && _tmpSO.pmCommercial.projectEngineerId == pe.projectEngineerId){
      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        //filters need to be added for user
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrdersPE(_tmpSO.subSalesOrder);
        //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
          // let currentYear:Date = new Date();
          let selYear:Date = new Date(this.yearFilterPE1.selYear,1,1);
          _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
            //Total No of order in hand
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)==true) {
                var temp: number = parseInt(e.panelQuantity, 10);
                var minrFlag : boolean = false;
                if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                  minrFlag = true;
                }
                if (temp > 0) {
                //   if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                //   _totalQtySO += temp;
                //   if(minrFlag){
                //     _totalContractualValue += parseFloat(e.contractualValue);
                //   }
                // }
                  ///Total number of orders Drawing approval done in current year
          
                  if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && selYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )) {
                    _totalQtySODrgApprovalDone +=temp;
                    if(minrFlag){
                      _totalContractualValueDrgApprovalDone += parseFloat(e.contractualValue);
                    }
                  }

                  //Total number of panels dispatched in current year

                  if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                    // _totalQtySODispatch += temp;
                    if(minrFlag){
                      _totalContractualValueDispatch += parseFloat(e.contractualValue);
                    }
                  }
                }
              }
            });
            if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
              _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
              }
            
            
          });
          // No of panels and MINR for OBL
          if (_tmpSO.projectStatus != SOStatus.Dispatched) {
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType) == true) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                    _totalQtySO += temp;
                    }
                    if (e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN") {
                      _totalContractualValue += parseFloat(e.contractualValue);
                    }
                  }
                });
              }
            });
          }
        }
      }
    }
    }
    });
    }
    else{
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      PEDesignEngineers.forEach((pe:ProjectEngineer) => {
        let _showSOWithNoSSO: boolean = true;
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO: SalesOrder = this._soObjList2[i];
          if(_tmpSO.pmCommercial.projectEngineerId != null && _tmpSO.pmCommercial.projectEngineerId != "" && _tmpSO.pmCommercial.projectEngineerId == pe.projectEngineerId){
          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrdersPE1(_tmpSO.subSalesOrder);
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
    
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
              // let currentYear:Date = new Date();
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                //Total No of order in hand
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)==true) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    var minrFlag : boolean = false;
                    if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                      minrFlag = true;
                    }
                    if (temp > 0) {
                    //   if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                    //   _totalQtySO += temp;
                    //   if(minrFlag){
                    //     _totalContractualValue += parseFloat(e.contractualValue);
                    //   }
                    // }
                      ///Total number of orders Drawing approval done in current year
              
                      // if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && currentYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )) {
                        if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null)) {
                        _totalQtySODrgApprovalDone +=temp;
                        if(minrFlag){
                          _totalContractualValueDrgApprovalDone += parseFloat(e.contractualValue);
                        }
                      }
    
                      //Total number of panels dispatched in current year
    
                      // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && currentYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                        if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                        // _totalQtySODispatch += temp;
                        if(minrFlag){
                          _totalContractualValueDispatch += parseFloat(e.contractualValue);
                        }
                      }
                    }
                  }
                });
                // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                  if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                    _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                    }
                
                
              });
              // No of panels and MINR for OBL
              if (_tmpSO.projectStatus != SOStatus.Dispatched) {
                _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                  if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType) == true) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                        _totalQtySO += temp;
                        }
                        if (e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN") {
                          _totalContractualValue += parseFloat(e.contractualValue);
                        }
                      }
                    });
                  }
                });
              }
            }
          }
        }
        }
        });
    }
    if(_totalQtySO!=0 || _totalQtySODrgApprovalDone!=0 || _totalQtySODispatch!=0){
      this.totalDataPE = [{
        "data":[
          {
            name: 'Total No. of orders in hand - OBL',
            x: Math.round(_totalContractualValue * 100)/100,
            y: _totalQtySO,
            color: '#ff000f'
          },
          {
            name: 'Total No. of orders Drawing approval done in current year',
            x: Math.round(_totalContractualValueDrgApprovalDone * 100)/100,
            y:_totalQtySODrgApprovalDone,
            color: '#262626'
          },
          
          {
            name: 'Total No. of panels dispatched in current year',
            x:Math.round(_totalContractualValueDispatch * 100)/100,
            y: _totalQtySODispatch,
             color: '#6e6e6e'
          }
          
        ]
      }        
     ];
    }
    else this.totalDataPE= null;

  this.totalDataPEKpiChartOptionsSO = this._kpiCharServ.getPieChartOptionsKPI(this.totalDataPE,"Project Engineer <br> KPI");  
    this.isDataViewUpdated = true;
    setTimeout(() => {
      this.isDataViewUpdated = false;
    }, 1000);
  }

  loadPEData(){
    this.isLoading2 = true;
    let PEDesignEngineers = this._dataService.projectEngineers;
    
    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    if(this.isYearFilterSelectedPE1==true){ 
      this.ProjectEngineerKPIArray =[];
    PEDesignEngineers.forEach((pe:ProjectEngineer) => {
      let _totalQtySO: number = 0;
      let _totalContractualValue: number = 0;
  
      let _totalQtySODrgApprovalDone: number = 0;
      let _totalContractualValueDrgApprovalDone: number = 0;
  
      let _totalQtySODispatch: number = 0;
      let _totalContractualValueDispatch: number = 0;
  
      let _showSOWithNoSSO: boolean = true;
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
        if(_tmpSO.pmCommercial.projectEngineerId != null && _tmpSO.pmCommercial.projectEngineerId != "" && _tmpSO.pmCommercial.projectEngineerId == pe.projectEngineerId){
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              
               // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  
                    // let currentYear:Date = new Date();
                    let selYear:Date = new Date(this.yearFilterPE1.selYear,1,1);
                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if(_equpList.includes(e.equipmentType)==true){
                        var temp: number = parseInt(e.panelQuantity, 10);

                        var minrFlag : boolean = false;
                        if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                          minrFlag = true;
                        }
        
                        if (temp > 0) {
                          // if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                          //   _totalQtySO += temp;
                          //   if(minrFlag){
                          //     _totalContractualValue += parseFloat(e.contractualValue);
                          //   }
                          // }
                          
                          ///Total number of orders Drawing approval done in current year
          
                  if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && selYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )) {
                    _totalQtySODrgApprovalDone +=temp;
                    if(minrFlag){
                      _totalContractualValueDrgApprovalDone += parseFloat(e.contractualValue);
                    }
                  }
                  
                          //Total number of panels dispatched in current year
        
                          if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                            // _totalQtySODispatch += temp;
                            if(minrFlag){
                              _totalContractualValueDispatch += parseFloat(e.contractualValue);
                            }
                          }
                        }
                      }
                    });
                    if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                      _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                      }
             
            });
            // No of panels and MINR for OBL
            if (_tmpSO.projectStatus != SOStatus.Dispatched) {
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                  subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                    if (_equpList.includes(e.equipmentType) == true) {
                      var temp: number = parseInt(e.panelQuantity, 10);
                      if (temp > 0) {
                      _totalQtySO += temp;
                      }
                      if (e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN") {
                        _totalContractualValue += parseFloat(e.contractualValue);
                      }
                    }
                  });
                }
              });
            }
          }
        }
      }
      }

       this.ProjectEngineerKPIArray.push(new ProjectEngineerKPI2(pe.projectEngineerName,_totalQtySO,_totalContractualValue,_totalQtySODrgApprovalDone,_totalContractualValueDrgApprovalDone,
        _totalQtySODispatch,_totalContractualValueDispatch));
      
    });
    }
    else{
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      this.ProjectEngineerKPIArray =[];
      PEDesignEngineers.forEach((pe:ProjectEngineer) => {
        let _totalQtySO: number = 0;
        let _totalContractualValue: number = 0;
    
        let _totalQtySODrgApprovalDone: number = 0;
        let _totalContractualValueDrgApprovalDone: number = 0;
    
        let _totalQtySODispatch: number = 0;
        let _totalContractualValueDispatch: number = 0;
    
        let _showSOWithNoSSO: boolean = true;
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO: SalesOrder = this._soObjList2[i];
          if(_tmpSO.pmCommercial.projectEngineerId != null && _tmpSO.pmCommercial.projectEngineerId != "" && _tmpSO.pmCommercial.projectEngineerId == pe.projectEngineerId){
          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
  
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
    
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                
                 // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                      // let currentYear:Date = new Date();
                      subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                        if(_equpList.includes(e.equipmentType)==true){
                          var temp: number = parseInt(e.panelQuantity, 10);
  
                          var minrFlag : boolean = false;
                          if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                            minrFlag = true;
                          }
          
                          if (temp > 0) {
                            // if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                            //   _totalQtySO += temp;
                            //   if(minrFlag){
                            //     _totalContractualValue += parseFloat(e.contractualValue);
                            //   }
                            // }
                            
                            ///Total number of orders Drawing approval done in current year
            
                    // if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && currentYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )) {
                      if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null)) {
                      _totalQtySODrgApprovalDone +=temp;
                      if(minrFlag){
                        _totalContractualValueDrgApprovalDone += parseFloat(e.contractualValue);
                      }
                    }
                    
                            //Total number of panels dispatched in current year
          
                            // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && currentYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                              if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                              // _totalQtySODispatch += temp;
                              if(minrFlag){
                                _totalContractualValueDispatch += parseFloat(e.contractualValue);
                              }
                            }
                          }
                        }
                      });
                      // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                        if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                          _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                          }
                    }
               
              });
              // No of panels and MINR for OBL
              if (_tmpSO.projectStatus != SOStatus.Dispatched) {
                _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                  if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType) == true) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                        _totalQtySO += temp;
                        }
                        if (e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN") {
                          _totalContractualValue += parseFloat(e.contractualValue);
                        }
                      }
                    });
                  }
                });
              }
            }
          }
        }
        }
  
         this.ProjectEngineerKPIArray.push(new ProjectEngineerKPI2(pe.projectEngineerName,_totalQtySO,_totalContractualValue,_totalQtySODrgApprovalDone,_totalContractualValueDrgApprovalDone,
          _totalQtySODispatch,_totalContractualValueDispatch));
        
      });    
    }
this.isLoading2 = false;
  }

  filterRowsLogic5() {
    let MEDesignEngineers = this._dataService.marketingEngineers;
    let _totalQtySO: number = 0;
    let _totalContractualValue: number = 0;

    let _totalQtyHandOver: number = 0;
    let _totalContractualValueHandOver: number = 0;


    let _totalQtySODispatch: number = 0;
    let _totalContractualValueDispatch: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];
    if(this.isYearFilterSelectedME1==true){
    MEDesignEngineers.forEach((me:MarketingEngineer) => {
    let _showSOWithNoSSO: boolean = true;
    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList2[i];
      if(_tmpSO.marketingIP.marketingEngineerId != null && _tmpSO.marketingIP.marketingEngineerId != "" && _tmpSO.marketingIP.marketingEngineerId == me.marketingEngineerId){
      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        //filters need to be added for user
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrdersME(_tmpSO.subSalesOrder);
        //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
          // let currentYear:Date = new Date();
          let selYear:Date = new Date(this.yearFilterME1.selYear,1,1);
          _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
            //Total No of order in hand
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)==true) {
                var temp: number = parseInt(e.panelQuantity, 10);
                var minrFlag : boolean = false;
                if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                  minrFlag = true;
                }
                if (temp > 0) {
                //   if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                //   _totalQtySO += temp;
                //   if(minrFlag){
                //     _totalContractualValue += parseFloat(e.contractualValue);
                //   }
                // }
                  ///Total number of order handed over
          
                  if (_tmpSO.marketingIP.actualHandingOverDate != null && selYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() ) {
                    _totalQtyHandOver +=temp;
                    if(minrFlag){
                      _totalContractualValueHandOver += parseFloat(e.contractualValue);
                    }
                  }

                  //Total number of panels dispatched in current year

                  if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                    // _totalQtySODispatch += temp;
                    if(minrFlag){
                      _totalContractualValueDispatch += parseFloat(e.contractualValue);
                    }
                  }
                }
              }
            });
            if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
              _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
              }
            
          });
          // No of panels and MINR for OBL
          if (_tmpSO.projectStatus != SOStatus.Dispatched) {
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType) == true) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                    _totalQtySO += temp;
                    }
                    if (e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN") {
                      _totalContractualValue += parseFloat(e.contractualValue);
                    }
                  }
                });
              }
            });
          }
        }
      }
    }
    }
  });
    }
    else{
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      MEDesignEngineers.forEach((me:MarketingEngineer) => {
        let _showSOWithNoSSO: boolean = true;
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO: SalesOrder = this._soObjList2[i];
          if(_tmpSO.marketingIP.marketingEngineerId != null && _tmpSO.marketingIP.marketingEngineerId != "" && _tmpSO.marketingIP.marketingEngineerId == me.marketingEngineerId){
          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrdersME1(_tmpSO.subSalesOrder);
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
    
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
              // let currentYear:Date = new Date();
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                //Total No of order in hand
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)==true) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    var minrFlag : boolean = false;
                    if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                      minrFlag = true;
                    }
                    if (temp > 0) {
                    //   if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                    //   _totalQtySO += temp;
                    //   if(minrFlag){
                    //     _totalContractualValue += parseFloat(e.contractualValue);
                    //   }
                    // }
                      ///Total number of order handed over
              
                      // if (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() ) {
                        if (_tmpSO.marketingIP.actualHandingOverDate != null) {
                        _totalQtyHandOver +=temp;
                        if(minrFlag){
                          _totalContractualValueHandOver += parseFloat(e.contractualValue);
                        }
                      }
    
                      //Total number of panels dispatched in current year
    
                      // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && currentYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                        if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                        // _totalQtySODispatch += temp;
                        if(minrFlag){
                          _totalContractualValueDispatch += parseFloat(e.contractualValue);
                        }
                      }
                    }
                  }
                });
                // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                  if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                    _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                    }
                
              });
              // No of panels and MINR for OBL
              if (_tmpSO.projectStatus != SOStatus.Dispatched) {
                _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                  if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType) == true) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                        _totalQtySO += temp;
                        }
                        if (e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN") {
                          _totalContractualValue += parseFloat(e.contractualValue);
                        }
                      }
                    });
                  }
                });
              }
            }
          }
        }
        }
      });
    }
    if(_totalQtySO!=0 || _totalQtyHandOver!=0 || _totalQtySODispatch!=0){
      this.totalDataME = [{
        "data":[
          {
            name: 'Total No. of orders in hand - OBL',
            x: Math.round(_totalContractualValue * 100)/100,
            y: _totalQtySO,
            color: '#ff000f'
          },
          {
            name: 'Total No. of order handed over in current year',
            x: Math.round(_totalContractualValueHandOver * 100)/100,
            y:_totalQtyHandOver,
            color: '#262626'
          },
          
          {
            name: 'Total No. of panels dispatched in current year',
            x: Math.round(_totalContractualValueDispatch * 100)/100,
            y: _totalQtySODispatch,
             color: '#6e6e6e'
          }
          
        ]
      }        
     ];
    }
    else this.totalDataME= null;

  this.totalDataMEKpiChartOptionsSO = this._kpiCharServ.getPieChartOptionsKPI(this.totalDataME,"Marketing Engineer <br> KPI");  
    this.isDataViewUpdated = true;
    setTimeout(() => {
      this.isDataViewUpdated = false;
    }, 1000);
  }

  loadMEData(){
    this.isLoading2 = true;
    let MEDesignEngineers = this._dataService.marketingEngineers;
    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];
    if(this.isYearFilterSelectedME1==true){
      this.MarketingEngineerKPIArray = [];
    MEDesignEngineers.forEach((me:MarketingEngineer) => {
      let _totalQtySO: number = 0;
      let _totalContractualValue: number = 0;
  
      let _totalQtyHandOver: number = 0;
      let _totalContractualValueHandOver: number = 0;
  
      let _totalQtySODispatch: number = 0;
      let _totalContractualValueDispatch: number = 0;
  
      let _showSOWithNoSSO: boolean = true;
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
        if(_tmpSO.marketingIP.marketingEngineerId != null && _tmpSO.marketingIP.marketingEngineerId != "" && _tmpSO.marketingIP.marketingEngineerId == me.marketingEngineerId){
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
               // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  
                    // let currentYear:Date = new Date();
                    let selYear:Date = new Date(this.yearFilterME1.selYear,1,1);
                    
                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if(_equpList.includes(e.equipmentType)==true){
                        var temp: number = parseInt(e.panelQuantity, 10);

                        var minrFlag : boolean = false;
                        if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                          minrFlag = true;
                        }
        
                        if (temp > 0) {
                          // if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                          //   _totalQtySO += temp;
                          //   if(minrFlag){
                          //     _totalContractualValue += parseFloat(e.contractualValue);
                          //   }
                          // }
                          
                          ///Total number of order handed over
          
                  if (_tmpSO.marketingIP.actualHandingOverDate != null && selYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() ) {
                    _totalQtyHandOver +=temp;
                    if(minrFlag){
                      _totalContractualValueHandOver += parseFloat(e.contractualValue);
                    }
                  }
                          //Total number of panels dispatched in current year
        
                          if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                            // _totalQtySODispatch += temp;
                            if(minrFlag){
                              _totalContractualValueDispatch += parseFloat(e.contractualValue);
                            }
                          }
                        }
                      }
                    });
                    if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                      _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                      }
                  }
             
            });
            // No of panels and MINR for OBL
            if (_tmpSO.projectStatus != SOStatus.Dispatched) {
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                  subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                    if (_equpList.includes(e.equipmentType) == true) {
                      var temp: number = parseInt(e.panelQuantity, 10);
                      if (temp > 0) {
                      _totalQtySO += temp;
                      }
                      if (e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN") {
                        _totalContractualValue += parseFloat(e.contractualValue);
                      }
                    }
                  });
                }
              });
            }
          }
        }
      }
      }

       this.MarketingEngineerKPIArray.push(new MarketingEngineerKPI2(me.marketingEngineerName,_totalQtySO,_totalContractualValue,_totalQtyHandOver,_totalContractualValueHandOver,
        _totalQtySODispatch,_totalContractualValueDispatch));
      
    });
    }
    else{
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      this.MarketingEngineerKPIArray = [];
      MEDesignEngineers.forEach((me:MarketingEngineer) => {
        let _totalQtySO: number = 0;
        let _totalContractualValue: number = 0;
    
        let _totalQtyHandOver: number = 0;
        let _totalContractualValueHandOver: number = 0;
    
        let _totalQtySODispatch: number = 0;
        let _totalContractualValueDispatch: number = 0;
    
        let _showSOWithNoSSO: boolean = true;
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO: SalesOrder = this._soObjList2[i];
          if(_tmpSO.marketingIP.marketingEngineerId != null && _tmpSO.marketingIP.marketingEngineerId != "" && _tmpSO.marketingIP.marketingEngineerId == me.marketingEngineerId){
          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
  
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
    
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                 // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                    
                      // let currentYear:Date = new Date();
                      subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                        if(_equpList.includes(e.equipmentType)==true){
                          var temp: number = parseInt(e.panelQuantity, 10);
  
                          var minrFlag : boolean = false;
                          if(e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN"){
                            minrFlag = true;
                          }
          
                          if (temp > 0) {
                            // if(subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true){
                            //   _totalQtySO += temp;
                            //   if(minrFlag){
                            //     _totalContractualValue += parseFloat(e.contractualValue);
                            //   }
                            // }
                            
                            ///Total number of order handed over
            
                    // if (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() ) {
                      if (_tmpSO.marketingIP.actualHandingOverDate != null) {
                      _totalQtyHandOver +=temp;
                      if(minrFlag){
                        _totalContractualValueHandOver += parseFloat(e.contractualValue);
                      }
                    }
                            //Total number of panels dispatched in current year
          
                            // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && currentYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                              if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                              // _totalQtySODispatch += temp;
                              if(minrFlag){
                                _totalContractualValueDispatch += parseFloat(e.contractualValue);
                              }
                            }
                          }
                        }
                      });
                      // if(subSaleOrder.logisticIP.lastDeliveryActualDate != null && selYear.getFullYear() == subSaleOrder.logisticIP.lastDeliveryActualDate.getFullYear()){
                        if(subSaleOrder.logisticIP.lastDeliveryActualDate != null){
                        _totalQtySODispatch += subSaleOrder.logisticIP.totalDispatchQty
                        }
                    }
               
              });
              // No of panels and MINR for OBL
              if (_tmpSO.projectStatus != SOStatus.Dispatched) {
                _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                  if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                    subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType) == true) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                        _totalQtySO += temp;
                        }
                        if (e.contractualValue != null && e.contractualValue != "" && e.contractualValue != "NaN") {
                          _totalContractualValue += parseFloat(e.contractualValue);
                        }
                      }
                    });
                  }
                });
              }
            }
          }
        }
        }
  
         this.MarketingEngineerKPIArray.push(new MarketingEngineerKPI2(me.marketingEngineerName,_totalQtySO,_totalContractualValue,_totalQtyHandOver,_totalContractualValueHandOver,
          _totalQtySODispatch,_totalContractualValueDispatch));
        
      });
    }
this.isLoading2 = false;
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOUserFilterPassed(_sso.enggDrawIP.electricalDesignEngineerId) == false) return false;
      return true;
    });
  }
  private getFilteredSubOrders1(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOUserFilterPassed(_sso.enggDrawIP.electricalDesignEngineerId) == false) return false;
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
      return true;
    });
  }

  private isSSOUserFilterPassed(_elecEngId:string):boolean{
    //check for failure cases
    if(this.isUserSelectionFilterSelected == true && this.userSelectionType != userFilterOption.All){
      if(this.userSelectionType == userFilterOption.ElectricDesignEngineer){
        if(!this.ElecDesignEnggArray.includes(_elecEngId)) return false;
      }
    }
    return true;
  }

  private getFilteredSubOrdersMech(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOMechUserFilterPassed(_sso.enggDrawIP.mechanicalDesignEngineerId) == false) return false;
      return true;
    });
  }
  private getFilteredSubOrdersMech1(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOMechUserFilterPassed(_sso.enggDrawIP.mechanicalDesignEngineerId) == false) return false;
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
      return true;
    });
  }

  private isSSOMechUserFilterPassed(_mechEngId:string):boolean{
    //check for failure cases
    if(this.isMechUserSelectionFilterSelected == true && this.userMechSelectionType != userFilterOption.All){
      if(this.userMechSelectionType == userFilterOption.MechanicalDesignEngineer){
        if(!this.MechanicalDesignEnggArray.includes(_mechEngId)) return false;
      }
    }
    
    return true;
  }

  private getFilteredSubOrdersPE(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOPEUserFilterPassed(_sso.parentSORef.pmCommercial.projectEngineerId) == false) return false;
      return true;
    });
  }
  private getFilteredSubOrdersPE1(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOPEUserFilterPassed(_sso.parentSORef.pmCommercial.projectEngineerId) == false) return false;
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
      return true;
    });
  }

  private isSSOPEUserFilterPassed(_peEngId:string):boolean{
    //check for failure cases
    if(this.isPEUserSelectionFilterSelected == true && this.userPESelectionType != userFilterOption.All){
      if(this.userPESelectionType == userFilterOption.ProjectEngineer){
        if(!this.ProjectEnggArray.includes(_peEngId)) return false;
      }
    }
    
    return true;
  }

  private getFilteredSubOrdersME(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOMEUserFilterPassed(_sso.parentSORef.marketingIP.marketingEngineerId) == false) return false;
      return true;
    });
  }
  private getFilteredSubOrdersME1(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOMEUserFilterPassed(_sso.parentSORef.marketingIP.marketingEngineerId) == false) return false;
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
      return true;
    });
  }

  private isSSOMEUserFilterPassed(_meEngId:string):boolean{
    //check for failure cases
    if(this.isMarketingEnggUserSelectionFilterSelected == true && this.userMarketingEnggSelectionType != userFilterOption.All){
      if(this.userMarketingEnggSelectionType == userFilterOption.MarketingEngineer){
        if(!this.MarketingEnggArray.includes(_meEngId)) return false;
      }
    }
    
    return true;
  }

  getYearNamePE1():string{
    if(this.yearFilterPE1){
      return this.yearFilterPE1.yearName;
    }
    return '';
  }
  
  getYearLabelPE1():string{
    if(this.isYearFilterSelectedPE1 == true){
      return "Year : ";
    }
    else{
      return "Enable Year Filter";
    }
  }
  prevYearPE1(){
    this.yearFilterPE1.prevYear();
    this.filterRowsPE();
  }
  nextYearPE1(){
    this.yearFilterPE1.nextYear();
    this.filterRowsPE();
  }

  // EDE
  getYearNameEDE1():string{
    if(this.yearFilterEDE1){
      return this.yearFilterEDE1.yearName;
    }
    return '';
  }
  
  getYearLabelEDE1():string{
    if(this.isYearFilterSelectedEDE1 == true){
      return "Year : ";
    }
    else{
      return "Enable Year Filter";
    }
  }
  prevYearEDE1(){
    this.yearFilterEDE1.prevYear();
    this.filterRows();
  }
  nextYearEDE1(){
    this.yearFilterEDE1.nextYear();
    this.filterRows();
  }

  // MDE
  getYearNameMDE1():string{
    if(this.yearFilterMDE1){
      return this.yearFilterMDE1.yearName;
    }
    return '';
  }
  
  getYearLabelMDE1():string{
    if(this.isYearFilterSelectedMDE1 == true){
      return "Year : ";
    }
    else{
      return "Enable Year Filter";
    }
  }
  prevYearMDE1(){
    this.yearFilterMDE1.prevYear();
    this.filterRowsMech();
  }
  nextYearMDE1(){
    this.yearFilterMDE1.nextYear();
    this.filterRowsMech();
  }
  // ME
  getYearNameME1():string{
    if(this.yearFilterME1){
      return this.yearFilterME1.yearName;
    }
    return '';
  }
  
  getYearLabelME1():string{
    if(this.isYearFilterSelectedME1 == true){
      return "Year : ";
    }
    else{
      return "Enable Year Filter";
    }
  }
  prevYearME1(){
    this.yearFilterME1.prevYear();
    this.filterRowsME();
  }
  nextYearME1(){
    this.yearFilterME1.nextYear();
    this.filterRowsME();
  }

  exportasexcelEDE(){
    let element = document.getElementById('EDE-table');
      //Export to excel
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { cellDates:true,dateNF:'mm/dd/yyyy;@',
        raw: false
      });//converts a DOM TABLE element to a worksheet      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     
      /* save to file */
      XLSX.writeFile(wb, 'elec-design-engg-2.xlsx');
  
  }

  exportasexcelMDE(){
    let element = document.getElementById('MDE-table');
      //Export to excel
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { cellDates:true,dateNF:'mm/dd/yyyy;@',
        raw: false
      });//converts a DOM TABLE element to a worksheet      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     
      /* save to file */
      XLSX.writeFile(wb, 'mech-design-engg-2.xlsx');
  
  }

  exportasexcelPE(){
    let element = document.getElementById('PE-table');
      //Export to excel
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { cellDates:true,dateNF:'mm/dd/yyyy;@',
        raw: false
      });//converts a DOM TABLE element to a worksheet      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     
      /* save to file */
      XLSX.writeFile(wb, 'pe-engg-2.xlsx');
  
  }

  exportasexcelME(){
    let element = document.getElementById('ME-table');
      //Export to excel
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { cellDates:true,dateNF:'mm/dd/yyyy;@',
        raw: false
      });//converts a DOM TABLE element to a worksheet      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     
      /* save to file */
      XLSX.writeFile(wb, 'me-engg-2.xlsx');
  
  }

  
}
